namespace AgerLMS.Coaching {
    export interface HeatMapData {
        categories?: string[];
        seriesData?: number[][];
        days?: { [key: string]: string };
    }
}
